export default __webpack_public_path__ + "static/media/reset.f8683275.png";